// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c84d1de1","977":"0a8db0f4"}[chunkId] + ".chunk.js";
};